/**
 * Shared Sentry deployment environment helpers.
 * Client builds must use NEXT_PUBLIC_VERCEL_ENV (exposed via next.config.js env).
 */
export function getSentryEnvironment(): string {
  if (typeof window !== "undefined") {
    return (
      process.env.NEXT_PUBLIC_VERCEL_ENV ||
      process.env.NODE_ENV ||
      "development"
    );
  }

  return (
    process.env.VERCEL_ENV ||
    process.env.NODE_ENV ||
    "development"
  );
}

export function getSentryTracesSampleRate(environment: string): number {
  return environment === "production" ? 0.1 : 1;
}

export function getSentryDeploymentHost(): string | undefined {
  if (typeof window !== "undefined") {
    return window.location.hostname;
  }

  const vercelUrl = process.env.VERCEL_URL;
  if (vercelUrl) {
    return vercelUrl.replace(/^https?:\/\//, "");
  }

  return undefined;
}

export function applySentryDeploymentTags(scope: {
  setTag: (key: string, value: string) => void;
}): void {
  const host = getSentryDeploymentHost();
  if (host) {
    scope.setTag("deployment_host", host);
  }
}
